exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".galaxy\\:\\:common-canvas-editor-canvas-Tabs .tab-btn[data-v-fbb39f38]{padding:6px 10px;cursor:pointer;border:none;outline:none}.galaxy\\:\\:common-canvas-editor-canvas-Tabs .tab-btn.active[data-v-fbb39f38]{border-bottom:2px solid #3899ec}", ""]);

